import { autocomplete } from '@algolia/autocomplete-js'
import React, { createElement, Fragment, useEffect, useRef } from 'react'
import { render } from 'react-dom'

const Autocomplete = (props) => {
    const containerRef = useRef(null)
    const autocompleteRef = useRef(null)

    useEffect(() => {
        // ✅ wait until ref is mounted
        if (!containerRef.current) return

        const search = autocomplete({
            container: containerRef.current,
            renderer: { createElement, Fragment },
            render({ children }, root) {
                render(children, root)
            },

            ...props,
        })

        autocompleteRef.current = search

        // ✅ close dropdown on outside click
        const handleDocumentClick = (event) => {
            const panel = document.querySelector('.aa-Panel')

            if (
                containerRef.current &&
                !containerRef.current.contains(event.target) &&
                !(panel && panel.contains(event.target))
            ) {
                autocompleteRef.current?.setIsOpen(false)
            }
        }

        document.addEventListener('click', handleDocumentClick)

        return () => {
            document.removeEventListener('click', handleDocumentClick)
            search.destroy()
        }
    }, [props]) // ✅ important for staging

    return <div ref={containerRef} className="autocomplete-container" />
}

export default Autocomplete
